export default __webpack_public_path__ + "assets/paraguay-flag.png";